import { ErrorHandler, Injectable, Injector } from '@angular/core';
import { LoggingService } from './error-logging.service';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
  logger: any;
  warnings = [`You provided 'undefined' where a stream was expected.`, 'Uncaught (in promise): [object Undefined]'];
  constructor(private injector: Injector) {
    this.logger = this.injector.get(LoggingService);
  }

  handleError(error: Error) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    const message = error?.message;

    if (!!message && this.warnings.includes(message)) return this.logger.logError(message, error, 'warning');

    if (chunkFailedMessage.test(message)) return window.location.reload();
    else this.logger.logError(message, error, 'fatal');
  }
}
